module.exports = __webpack_public_path__ + "static/mapa-certificaciones-33d5103af437fa353c1abf6546b945dd.png";